import { API_URL } from "../Constant";

const daftarAkunURL = API_URL + "daftarakun/";

export const daftarAkunAxiosGet = async (axiosInstance) =>
  axiosInstance.get(daftarAkunURL);
export const daftarAkunAxiosGetByPk = async (axiosInstance, statePk) =>
  axiosInstance.get(daftarAkunURL + statePk);
export const daftarAkunAxiosCreate = async (axiosInstance, state) =>
  axiosInstance.post(daftarAkunURL, state);
export const daftarAkunAxiosUpdate = async (axiosInstance, statePk, state) =>
  axiosInstance.put(daftarAkunURL + statePk, state);
export const daftarAkunAxiosDelete = async (axiosInstance, statePk) =>
  axiosInstance.delete(daftarAkunURL + statePk);

const dokumenURL = API_URL + "dokumen/";

export const dokumenAxiosGet = async (axiosInstance) =>
  axiosInstance.get(dokumenURL);
export const dokumenAxiosGetByPk = async (axiosInstance, statePk) =>
  axiosInstance.get(dokumenURL + statePk);
export const dokumenAxiosCreate = async (axiosInstance, state) =>
  axiosInstance.post(dokumenURL, state);
export const dokumenAxiosUpdate = async (axiosInstance, statePk, state) =>
  axiosInstance.put(dokumenURL + statePk, state);
export const dokumenAxiosDelete = async (axiosInstance, statePk) =>
  axiosInstance.delete(dokumenURL + statePk);

const jeniskegiatanURL = API_URL + "jeniskegiatan/";

export const jeniskegiatanAxiosGet = async (axiosInstance) =>
  axiosInstance.get(jeniskegiatanURL);
export const jeniskegiatanAxiosGetByPk = async (axiosInstance, statePk) =>
  axiosInstance.get(jeniskegiatanURL + statePk);
export const jeniskegiatanAxiosCreate = async (axiosInstance, state) =>
  axiosInstance.post(jeniskegiatanURL, state);
export const jeniskegiatanAxiosUpdate = async (axiosInstance, statePk, state) =>
  axiosInstance.put(jeniskegiatanURL + statePk, state);
export const jenisKegiatanAxiosDelete = async (axiosInstance, statePk) =>
  axiosInstance.delete(jeniskegiatanURL + statePk);

const kategoriKegiatanURL = API_URL + "kategorikegiatan/";

export const kategoriKegiatanAxiosGet = async (axiosInstance) =>
  axiosInstance.get(kategoriKegiatanURL);
export const kategoriKegiatanAxiosGetByPk = async (axiosInstance, statePk) =>
  axiosInstance.get(kategoriKegiatanURL + statePk);
export const kategoriKegiatanAxiosCreate = async (axiosInstance, state) =>
  axiosInstance.post(kategoriKegiatanURL, state);
export const kategoriKegiatanAxiosUpdate = async (
  axiosInstance,
  statePk,
  state
) => axiosInstance.put(kategoriKegiatanURL + statePk, state);
export const kategoriKegiatanAxiosDelete = async (axiosInstance, statePk) =>
  axiosInstance.delete(kategoriKegiatanURL + statePk);

const kegiatanURL = API_URL + "kegiatan/";

export const kegiatanAxiosGet = async (axiosInstance) =>
  axiosInstance.get(kegiatanURL);
export const kegiatanAxiosGetByPk = async (axiosInstance, statePk) =>
  axiosInstance.get(kegiatanURL + statePk);
export const kegiatanAxiosCreate = async (axiosInstance, state) =>
  axiosInstance.post(kegiatanURL, state);
export const kegiatanAxiosUpdate = async (axiosInstance, statePk, state) =>
  axiosInstance.put(kegiatanURL + statePk, state);
export const kegiatanAxiosDelete = async (axiosInstance, statePk) =>
  axiosInstance.delete(kegiatanURL + statePk);

const sumberDanaURL = API_URL + "sumberdana/";

export const sumberDanaAxiosGet = async (axiosInstance) =>
  axiosInstance.get(sumberDanaURL);
export const sumberDanaAxiosGetByPk = async (axiosInstance, statePk) =>
  axiosInstance.get(sumberDanaURL + statePk);
export const sumberDanaAxiosCreate = async (axiosInstance, state) =>
  axiosInstance.post(sumberDanaURL, state);
export const sumberDanaAxiosUpdate = async (axiosInstance, statePk, state) =>
  axiosInstance.put(sumberDanaURL + statePk, state);
export const sumberDanaAxiosDelete = async (axiosInstance, statePk) =>
  axiosInstance.delete(sumberDanaURL + statePk);

const unitKerjaURL = API_URL + "unitkerja/";

export const unitKerjaAxiosGet = async (axiosInstance) =>
  axiosInstance.get(unitKerjaURL);
export const unitKerjaAxiosGetByPk = async (axiosInstance, statePk) =>
  axiosInstance.get(unitKerjaURL + statePk);
export const unitKerjaAxiosCreate = async (axiosInstance, state) =>
  axiosInstance.post(unitKerjaURL, state);
export const unitKerjaAxiosUpdate = async (axiosInstance, statePk, state) =>
  axiosInstance.put(unitKerjaURL + statePk, state);
export const unitKerjaAxiosDelete = async (axiosInstance, statePk) =>
  axiosInstance.delete(unitKerjaURL + statePk);

const userRoleURL = API_URL + "userrole/";

export const userRoleAxiosGet = async (axiosInstance) =>
  axiosInstance.get(userRoleURL);
export const userRoleAxiosGetByPk = async (axiosInstance, statePk) =>
  axiosInstance.get(userRoleURL + statePk);
export const userRoleAxiosCreate = async (axiosInstance, state) =>
  axiosInstance.post(userRoleURL, state);
export const userRoleAxiosUpdate = async (axiosInstance, statePk, state) =>
  axiosInstance.put(userRoleURL + statePk, state);
export const userRoleAxiosDelete = async (axiosInstance, statePk) =>
  axiosInstance.delete(userRoleURL + statePk);
